export const ADM_RULES = [
  { value: 'up1d', label: 'Universitário por um dia' },
  { value: 'cuco', label: 'CUCO' },
  { value: 'ferramentas', label: 'Ferramentas' },
]

export const ALL_ADM_RULES = ADM_RULES.map((rule) => rule.value)

export function parseRulesAdm(value) {
  if (Array.isArray(value)) {
    return value.filter((rule) => ALL_ADM_RULES.includes(rule))
  }

  if (!value || typeof value !== 'string') {
    return []
  }

  try {
    const parsed = JSON.parse(value)
    if (Array.isArray(parsed)) {
      return parsed.filter((rule) => ALL_ADM_RULES.includes(rule))
    }
  } catch (error) {
    return value
      .split(',')
      .map((rule) => rule.trim())
      .filter((rule) => ALL_ADM_RULES.includes(rule))
  }

  return []
}

export function isSuperAdm(adm) {
  return Number(adm?.typeAdm) === 1
}

export function getAdmRules(adm) {
  if (isSuperAdm(adm)) {
    return [...ALL_ADM_RULES]
  }

  return parseRulesAdm(adm?.rulesAdm)
}

export function hasAdmRule(adm, rule) {
  return isSuperAdm(adm) || getAdmRules(adm).includes(rule)
}

export function getRuleLabel(rule) {
  return ADM_RULES.find((item) => item.value === rule)?.label || rule
}
